import { writable } from "svelte/store";

// Used to set the theme of the Global Navigation
export const heroThemeStore = writable("transparent");

// Used to store applied filter items
export const filterItemsStore = writable([]);

export const selectedNewsletters = writable({});
